module.exports = __webpack_public_path__ + "img/login.a28443e8.svg";